import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminCategories, AdminCategoriesShow } from 'containers'

export const AdminCategoriesRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminCategories />} />
      <Route path="/:slug" element={<AdminCategoriesShow />} />
    </Routes>
  )
}
